<!--  -->
<template>
  <div class="contianer">
    <div class="con">
      <img class="bgimg" src="../../assets/images/h5/01.jpg" alt="" />
      <img class="bgimg" src="../../assets/images/h5/02.jpg" alt="" />

      <div class="ac1_img">
        <div><img alt="" src="../../assets/images/h5/03.jpg" /></div>
        <div><img alt="" src="../../assets/images/h5/04.jpg" @click="goto('19733')" /></div>
      </div>
      <div class="ac1_img">
        <div><img alt="" src="../../assets/images/h5/05.jpg" @click="goto('18739')" /></div>
        <div><img alt="" src="../../assets/images/h5/06.jpg" @click="goto('19803')" /></div>
      </div>
      <div class="ac1_img">
       <div> <img alt="" src="../../assets/images/h5/07_2.jpg" @click="goto('18658',ifshow)" v-if="ifshow==1" /></div>
       <div> <img alt="" src="../../assets/images/h5/07_3.jpg" @click="goto('18658',ifshow)" v-if="ifshow==2" /></div>
       <div> <img alt="" src="../../assets/images/h5/07_4.jpg" @click="goto('18658',ifshow)" v-if="ifshow==3" /></div>
       <div> <img alt="" src="../../assets/images/h5/08_2.jpg" @click="goto('19470',ifshow2)" v-if="ifshow2==1" /></div>
       <div> <img alt="" src="../../assets/images/h5/08_3.jpg" @click="goto('19470',ifshow2)" v-if="ifshow2==2" /></div>
       <div> <img alt="" src="../../assets/images/h5/08_4.jpg" @click="goto('19470',ifshow2)" v-if="ifshow2==3" /></div>
      </div>
      <img class="bgimg" src="../../assets/images/h5/09.jpg" alt="" />
      <img class="bgimg" src="../../assets/images/h5/10.jpg" alt="" />
      <div class="ac2_img">
        <div><img alt="" src="../../assets/images/h5/11.jpg" @click="goto('19554')" /></div>
        <div><img alt="" src="../../assets/images/h5/12.jpg" @click="goto('18692')" /></div>
      </div>
      <div class="ac2_img">
        <div><img alt="" src="../../assets/images/h5/13.jpg" @click="goto('19307')" /></div>
        <div><img alt="" src="../../assets/images/h5/14.jpg" @click="goto('19297')" /></div>
      </div>
      <div class="ac2_img">
        <div><img alt="" src="../../assets/images/h5/15.jpg" @click="goto('19731')" /></div>
        <div><img alt="" src="../../assets/images/h5/16.jpg" @click="goto('9586')" /></div>
      </div>
      <img class="bgimg" src="../../assets/images/h5/17.jpg" alt="" />
      <img class="bgimg" src="../../assets/images/h5/18.jpg" alt="" />

      <div class="ac3_img">
        <div><img alt="" src="../../assets/images/h5/19.jpg" @click="goto('19118')" /></div>
        <div><img class="imgs" alt="" src="../../assets/images/h5/20.jpg" @click="goto('10192')" /></div>
        <div><img alt="" src="../../assets/images/h5/21.jpg" @click="goto('19718')" /></div>
      </div>
      <div class="ac3_img">
        <div><img alt="" src="../../assets/images/h5/22.jpg" @click="goto('19374')" /></div>
        <div><img class="imgs" alt="" src="../../assets/images/h5/23.jpg" @click="goto('19548')" /></div>
        <div><img alt="" src="../../assets/images/h5/24.jpg" @click="goto('19715')" /></div>
      </div>
      <div class="ac3_img">
       <div><img alt="" src="../../assets/images/h5/25.jpg" @click="goto('19400')" /></div>
       <div><img class="imgs" alt="" src="../../assets/images/h5/26.jpg" @click="goto('19396')" /></div>
       <div><img alt="" src="../../assets/images/h5/27.jpg" @click="goto('18854')" /></div>
      </div>
      <div class="ac3_img">
        <div><img alt="" src="../../assets/images/h5/28.jpg" @click="goto('9823')" /></div>
        <div><img class="imgs" alt="" src="../../assets/images/h5/29.jpg" @click="goto('4213')" /></div>
        <div><img alt="" src="../../assets/images/h5/30.jpg" @click="goto('19805')" /></div>
      </div>
      <div class="ac3_img">
        <div><img alt="" src="../../assets/images/h5/31.jpg" @click="goto('6105')" /></div>
        <div><img class="imgs" alt="" src="../../assets/images/h5/32.jpg" @click="goto('7642')" /></div>
        <div><img alt="" src="../../assets/images/h5/33.jpg" @click="goto('19215')" /></div>
      </div>
      <div class="ac3_img">
        <div><img alt="" src="../../assets/images/h5/34.jpg" @click="goto('19229')" /></div>
        <div><img class="imgs" alt="" src="../../assets/images/h5/35.jpg" @click="goto('19536')" /></div>
        <div><img alt="" src="../../assets/images/h5/36.jpg" @click="goto('19534')" /></div>
      </div>
      <img class="bgimg" src="../../assets/images/h5/37.jpg" alt="" />
      <img class="bgimg" src="../../assets/images/h5/38.jpg" alt="" />


    </div>
  </div>
</template>

<script>
import {queryStoreByProduct} from "@/api/api";
import axios from 'axios';

export default {
  components: {},
  data() {
    return {
      ifshow: 1,
      ifshow2: 1,
      timer: "",
      timer2: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
      goto(id,status) {
      if (status) {
        if (status==2) {
          this.$router.push({
          path: "/productDetails?id=" + id,
        });
        }
      }else{
        this.$router.push({
        path: "/productDetails?id=" + id,
      });
      }
      
    },
    async getStore(id){

     let res = await queryStoreByProduct({giftCode:id});
       if (res.code == '0000') {
       let store = res.data.available
       return store
     }
    }
  },
  created() {},
  mounted() {
    let this_ = this
    // 商品1
    let pro1 = this.getStore('18658')
    pro1.then(function(result) {
      const store1 = result
      if (new Date() < new Date("2021-11-25 10:00:00")) {
        this_.timer = setInterval(() => {
          if (new Date() >= new Date("2021-11-25 10:00:00")) {
            this_.ifshow = 2
            clearInterval(this_.timer)
          }
       }, 1000);
      }else if(new Date() > new Date("2021-11-25 10:00:00")&& store1>0){
        this_.ifshow = 2
      }else if (store1<1) {
        this_.ifshow = 3
      }
    })
    // 商品2
    let pro2 = this.getStore('19470')
    pro2.then(function(result) {
      const store2 = result
      if (new Date() < new Date("2021-11-25 15:00:00")) {
        this_.timer2 = setInterval(() => {
          if (new Date() >= new Date("2021-11-25 15:00:00")) {
            this_.ifshow2 = 2
            clearInterval(this_.timer2)
          }
        }, 1000);
      }else if(new Date() > new Date("2021-11-25 15:00:00")&& store2>0){
        this_.ifshow2 = 2
      }else if (store2<1) {
        this_.ifshow2 = 3
      }
    })
  },
};
</script>
<style lang='scss' scoped>
img{
  border:0;
  margin: 0;
  padding:0;
  vertical-align: middle;
  width: 100%;
}
.con {

  .ac1_img,.ac2_img{
    display: flex;
    img{cursor: pointer;}
  }
  .ac3_img{
    display: flex;
    img{cursor: pointer;}
  }
}
</style>